import type { Direction } from "../../../engine/direction";
import { BurstParticle } from "./burstParticle";

export class RobotDebrisParticle extends BurstParticle {
	constructor(originX: number, originY: number, direction?: Direction) {
		super(
			originX,
			originY,
			{
				ttl: [300, 700],
				size: [0.45, 0.3],
				color: { r: 70, g: 70, b: 75 },
				speed: [1, 4],
				gravity: 4.0,
			},
			direction,
		);
	}
}
